// extracted by mini-css-extract-plugin
export default {"figure":"BodyDogImgRight_figure__bNX6e","caption":"BodyDogImgRight_caption__FJSo0"};